// ======================================================================
// File Name       : ContentDocumentContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import $ from 'jquery';
import { Field, reduxForm, isInvalid, getFormValues, change, submit } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Form, Col } from 'react-bootstrap';
import EnterpriseNoticeRegisterEditForm from '../../components/enterpriseNotification/EnterpriseNoticeRegisterEditForm';
import DialogConfirm from '../../components/DialogConfirm';
import * as EnterpriseAction from '../../actions/EnterpriseAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { USE_DATE_RELEASE, RELEASE_TARGET_NOTICE_FOR_ENTERPRISE } from '../../constants/EnterpriseNoticeConstants';
import { VALIDATE_TYPE, RETURN_MAX_NUM, DEFAULT_DATE_FORMAT_SERVER, DEFAULT_DATE_SHORT_FORMAT_SERVER } from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import { ENTERPRISE_NOTIFICATION_LIST } from '../../constants/PathConstants';
import { getSystemUsageMonthRange } from '../../utils/EnterPriseUtils';
import ModalConductor from '../../components/modal/ModalConductor';
import * as ModalIds from '../../constants/ModalIds';
import * as ModalAction from '../../actions/ModalAction';
import { hasProperty, parseDateForDetail } from '../../utils/index';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

class EnterpriseNoticeRegisterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noticeInfo: {
        noticeSecernId: null,
        noticeTitle: null,
        noticeContent: null,
        releaseTargetForEnterprise: 0,
        publicStatus: 1,
        publicDateFrom: moment(),
        publicDateTo: moment().add(1, 'month'),
        releasePeriod: USE_DATE_RELEASE.INDEFINITE_PERIOD,
      },
    };
    this.onConfirmDialogCancel = this.onConfirmDialogCancel.bind(this);
    this.onConfirmDialogOk = this.onConfirmDialogOk.bind(this);
    this.openConfirmDialog = this.openConfirmDialog.bind(this, MessageTemplate.BULK_EXPORT, null);
    this.radioChange = this.radioChange.bind(this);
  }

  openConfirmDialog() {
    this.props.dispatch(ModalAction.openModal(ModalIds.ENTERPRISE_NOTICE_CONFIRM));
  }

  /**
 * Action click cancel button in dialog
 */
  onConfirmDialogCancel() {
    this.setState({ showExportModal: false });
  }

  onConfirmDialogOk() {
    const { noticeInfo, history } = this.props;
    if (noticeInfo.releasePeriod == USE_DATE_RELEASE.INDEFINITE_PERIOD) {
      noticeInfo.publicDateFrom = null;
      noticeInfo.publicDateTo = null;
    }
    this.props.dispatch(EnterpriseAction.registerNoticeForEnterprise(noticeInfo)).then(() => {
      this.setState({ showExportModal: false });
      history.push(ENTERPRISE_NOTIFICATION_LIST);
    });
  }

  radioChange(event, newValue, previousValue) {
    const { formValues } = this.props;
    if (formValues && Object.keys(formValues).length) {
      const nameTarget = event.target.name;
      if (hasProperty(formValues, nameTarget)) {
        const newFormValue = { ...formValues };
        let publicDateFromTemp = '';
        let publicDateToTemp = '';
        if (hasProperty(formValues, 'publicDateFrom')) {
          publicDateFromTemp = parseDateForDetail(formValues.publicDateFrom, 'YYYY/MM/DD', '');
        }
        if (hasProperty(formValues, 'publicDateTo')) {
          publicDateToTemp = parseDateForDetail(formValues.publicDateTo, 'YYYY/MM/DD', '');
        }
        if (newValue === 1 && previousValue === 0 && publicDateFromTemp == '' && publicDateToTemp == '') {
          newFormValue.publicDateFrom = moment();
          newFormValue.publicDateTo = moment().add(1, 'month');
        } else if (publicDateFromTemp !== '' && publicDateToTemp !== '') {
          newFormValue.publicDateFrom = formValues.publicDateFrom;
          newFormValue.publicDateTo = formValues.publicDateTo;
        }
        newFormValue.releasePeriod = newValue;
        this.props.dispatch(change('EnterpriseNoticeRegister', nameTarget, newFormValue));
        this.props.dispatch(change('EnterpriseNoticeRegister', 'publicDateFrom', newFormValue.publicDateFrom));
        this.props.dispatch(change('EnterpriseNoticeRegister', 'publicDateTo', newFormValue.publicDateTo));
      }
    }
  }

  render() {
    const { noticeInfo } = this.props;
    return (
      <div>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.openConfirmDialog();
          }}
          className='form-horizontal'
        >
          <CustomLink
            className="margin-right-7 url-list"
            to={Path.ENTERPRISE_NOTIFICATION_LIST}
            text="企業向けお知らせ一覧に戻る"
            icon="bi bi-chevron-left"
          />
          <Header name="企業向けお知らせ情報の新規登録" />
          <Col className="padding-left-right-clear">
            登録する内容を指定してください
          </Col>
          <Col className="margin-top-10">
            <EnterpriseNoticeRegisterEditForm
              noticeTitle={noticeInfo.noticeTitle}
              noticeContent={noticeInfo.noticeContent}
              releasePeriod={noticeInfo.releasePeriod}
              releaseTargetForEnterprise={noticeInfo.releaseTargetForEnterprise}
              isEdit={false}
              publicDateFrom={noticeInfo.publicDateFrom}
              publicDateTo={noticeInfo.publicDateTo}
              radioChange={this.radioChange}
            />
          </Col>
          <Col className="text-center">
            <Button
              variant="primary"
              type="submit"
              className="btn-96 text-center margin-top-20"
              onClick={this.props.handleSubmit(this.openConfirmDialog)}
            >
              OK
            </Button>
          </Col>
          <ModalConductor history={this.props.history} />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let { noticeInfo } = state.enterpriseNotice;
  const { EnterpriseNoticeRegister } = state.form;
  noticeInfo =
    EnterpriseNoticeRegister && EnterpriseNoticeRegister.values
      ? EnterpriseNoticeRegister.values
      : noticeInfo;
  return {
    ...{ noticeInfo },
    initialValues: {
      noticeSecernId: null,
      noticeTitle: null,
      noticeContent: null,
      releaseTargetForEnterprise: 0,
      publicStatus: 1,
      publicDateFrom: '',
      publicDateTo: '',
      releasePeriod: USE_DATE_RELEASE.INDEFINITE_PERIOD,
    },
    invalid: isInvalid('EnterpriseNoticeRegister')(state),
    formValues: getFormValues('EnterpriseNoticeRegister')(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'EnterpriseNoticeRegister', // a unique identifier for this form
    touchOnBlur: true,
    touchOnChange: true,
  })(EnterpriseNoticeRegisterContainer),
);
